import * as React from 'react';
import classNames from 'classnames';
import './Input.scss';

export type InputType = 'text' | 'password' | 'email' | 'number';
export type ElementSize = 'small' | 'default' | 'large';
export type Variant = 'default' | 'inset';

export interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  elementSize?: ElementSize;
  className?: string;
  variant?: Variant;
  showErrorBorder?: boolean;
}

const Input = React.forwardRef((props: IProps, ref: React.RefObject<HTMLInputElement>) => {
  const {
    elementSize,
    className,
    variant,
    showErrorBorder,
    ...inputProps
  } = props;

  return (
    <input
      {...inputProps}
      ref={ref}
      className={classNames(
        'input',
        className,
        showErrorBorder && 'has-error-border',
        elementSize ? `is-${elementSize}` : 'is-small',
        variant ? `is-${variant}` : null,
      )}
    />
  );
});

export default Input;



// WEBPACK FOOTER //
// ./src/components/FormElements/Input.tsx